const StatusRegId = Object.freeze([
  { value: 1, label: "Pending" },
  { value: 2, label: "Registered" },
  { value: 3, label: "Expired" },
]);

export default StatusRegId;